var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H6.66667L7.2 6.66667M7.2 6.66667H28L22.6667 17.3333H9.33333M7.2 6.66667L9.33333 17.3333M9.33333 17.3333L6.27615 20.3905C5.43619 21.2305 6.03108 22.6667 7.21895 22.6667H22.6667M22.6667 22.6667C21.1939 22.6667 20 23.8605 20 25.3333C20 26.8061 21.1939 28 22.6667 28C24.1395 28 25.3333 26.8061 25.3333 25.3333C25.3333 23.8605 24.1395 22.6667 22.6667 22.6667ZM12 25.3333C12 26.8061 10.8061 28 9.33333 28C7.86057 28 6.66667 26.8061 6.66667 25.3333C6.66667 23.8605 7.86057 22.6667 9.33333 22.6667C10.8061 22.6667 12 23.8605 12 25.3333Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullCart);
export default __webpack_public_path__ + "static/media/full-cart.1a7c20347a0731f20eac07c9339b9590.svg";
export { ForwardRef as ReactComponent };